<script lang="ts">
  import RefundAdjustDonation from '../../components/admin/payroll/RefundAdjustDonation.svelte';
</script>

<div class="refund-adjust-donation-page">
  <RefundAdjustDonation />
</div>

<style>
  .refund-adjust-donation-page {
    min-height: 100vh;
    background-color: #f9fafb;
  }
</style> 